import React from 'react';
import { IService } from 'interfaces/services';
import ReactTooltip from 'react-tooltip';
import Status from 'components/Status/Status';
import ServiceDetails from './ServiceDetails';
import ServiceOrder from './ServiceOrder';

interface IProps {
  service: IService;
  onClick: () => void;
  selectedServiceId?: string;
  isCollapsed: boolean;
  header?: React.ReactNode;
  isOrdering?: boolean;
  currentIndex?: number;
  onMoveUp?: (index: number) => void;
  onMoveDown?: (index: number) => void;
  totalItems?: number;
  nextItemIsInactive?: boolean;
}

const ServiceItem = ({
  service,
  onClick,
  selectedServiceId,
  isCollapsed,
  header,
  isOrdering,
  currentIndex,
  onMoveUp,
  onMoveDown,
  totalItems = 0,
  nextItemIsInactive = false,
}: IProps) => {
  const { name, isActive, id, displayName } = service;

  const nameDisplay = displayName ? displayName : name;

  return (
    <div
      className={`min-h-[10.3rem] flex items-center pl-1.9 border-b border-light-grey ${isOrdering ? '' : 'cursor-pointer'}  ${
        selectedServiceId === id ? 'bg-lightPink' : 'bg-white'
      }`}
      onClick={onClick}
    >
      {isCollapsed && (
        <div
          className="flex items-center justify-center rounded-full bg-light-grey text-darkest-grey w-6 h-6 aspect-square text-10 font-bold shadow-elevation-07"
          data-for={id}
          data-tip=""
        >
          {nameDisplay
            .split(' ')
            .map((word) => word.charAt(0))
            .join('')
            .substring(0, 3)
            .toUpperCase()}
        </div>
      )}
      {isCollapsed ? (
        <ReactTooltip
          id={id}
          place="bottom"
          effect="solid"
          className="!bg-white !border-light-grey !rounded-[0.8rem] !w-auto !h-auto !px-[1rem] !py-[0.8rem] !opacity-100 z-[9999] flex flex-col justify-center items-center !min-w-[11.5rem] shadow-primary min-h-[6rem] before:hidden after:hidden"
        >
          <span className="text-11 leading-[1.8rem] text-darkest-grey flex items-center font-normal mb-0.2">
            {nameDisplay}
          </span>
          <Status isActive={isActive}>
            {isActive ? 'Active' : 'Inactive'}
          </Status>
        </ReactTooltip>
      ) : !isOrdering ? (
        <ServiceDetails service={service} header={header} />
      ) : (
        <ServiceOrder
          service={service}
          header={header}
          currentIndex={currentIndex!}
          onMoveUp={onMoveUp!}
          onMoveDown={onMoveDown!}
          totalItems={totalItems}
          nextItemIsInactive={nextItemIsInactive}
        />
      )}
    </div>
  );
};

export default ServiceItem;
